import React from 'react';
import { Typography, Box } from '@mui/material';
import PushPinRoundedIcon from '@mui/icons-material/PushPinRounded';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';
import { useTranslation } from 'react-i18next';
import Tooltip from '@src/components/Tooltip';
import { calculateElapsedDateTime } from '@src/utils/date';
import moment from 'moment';
import { StyledNotificationItem } from './index.style';

const NotificationItem = ({ notification, onClick }) => {
  const { i18n, t } = useTranslation();
  const { rawContent, sentAt, isPinned, readAt } = notification;
  const langContent = rawContent?.[i18n.language] || rawContent?.vi || {};
  const title = langContent.title || '';
  const description = langContent.description || '';
  const imageUrl = langContent.thumbnailUrl || '';

  const formattedDate = sentAt
    ? calculateElapsedDateTime(sentAt, t) ||
      moment(sentAt).format('DD/MM/YYYY - HH:mm')
    : '';

  return (
    <StyledNotificationItem
      $unread={!readAt}
      onClick={() => onClick(notification)}
    >
      <Box className="item-title-row">
        <Box className="item-title-container">
          {isPinned && (
            <Tooltip arrow title={t('notificationPinned')} placement="left">
              <PushPinRoundedIcon className="pin-icon" />
            </Tooltip>
          )}
          <Typography className={`item-title ${isPinned ? 'pinned' : ''}`}>
            {title}
          </Typography>
          <NavigateNextRoundedIcon className="navigate-icon" />
        </Box>
        {!readAt && <Box className="unread-indicator" />}
      </Box>
      {description && (
        <Typography className="item-description">{description}</Typography>
      )}
      {imageUrl && (
        <img src={imageUrl} alt={title} className="item-image" loading="lazy" />
      )}
      {formattedDate && (
        <Typography className="item-date">{formattedDate}</Typography>
      )}
    </StyledNotificationItem>
  );
};

export default NotificationItem;
